'use strict';

export default function($stateProvider) {
  'ngInject';
  $stateProvider
    .state('tvs_emerald_reportspec', {
      url: '/tvs_emerald_reportspec',
      template: '<tvsemeraldreportspectab></tvsemeraldreportspectab>'
    });
}
